import React from "react";

import { FormattedMessage } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";
import { ROUTES } from "~/constants/routes.consts";

import { useCreateSpaceLinkTracking } from "../../_hooks/useCreateSpaceLinkTracking";

const CtaBanner = () => {
  const linkRef = useCreateSpaceLinkTracking("cta_banner_section");

  return (
    <div className="tw-relative">
      <div className="tw-absolute tw-bg-gray-900 tw-w-full tw-h-[140px]" />
      <div className="tw-w-full tw-h-full tw-max-w-[864px] tw-px-32 tw-relative lg:tw-pb-80 tw-pb-36 tw-mx-auto">
        <div className="tw-w-full tw-h-full tw-bg-purple-600 tw-flex tw-flex-col tw-px-24 tw-py-32 lg:tw-px-[120px] lg:tw-py-[92px] tw-rounded-4">
          <div className="tw-flex tw-flex-col tw-gap-32 tw-w-full">
            <div className="tw-flex tw-flex-col tw-gap-16">
              <Text
                element="h2"
                typeface="headline-6-b"
                className="lg:tw-display-1-b tw-text-brand-white"
              >
                <FormattedMessage defaultMessage="Ready to put your space to work?" />
              </Text>
              <Text
                element="p"
                typeface="body-3"
                className="lg:tw-headline-1-m tw-text-brand-white"
              >
                <FormattedMessage defaultMessage="Create your free listing in minutes. No upfront costs, no monthly fees, no commitments. You only pay as you earn." />
              </Text>
            </div>
            <div>
              <Button
                appearance="white"
                href={ROUTES.CREATE_SPACE}
                // We're sending analytic event ("host list space clicked") on click of this link.
                // This ref allows Segment to handle onClick event itself and navigate user only after the tracking request was finsihed.
                // This prevents user from navigating faster than sending data to Segment.
                ref={linkRef}
              >
                <FormattedMessage defaultMessage="List your space now" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { CtaBanner };
